export const ANALYZER_STATUS_LABELS: Record<string, string> = {
  success: "Успешно",
  partial: "Частично",
  failed: "Ошибка",
  running: "Выполняется",
  idle: "Ожидание",
};
